import React, {PureComponent} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import UsaStateHovers from "../MapElements/UsaStateHovers";
import UsaStateBorders from "../MapElements/UsaStateBorders";

import {TEXT} from "../../../utilities/strings";

import '../MapElements/Map.css';

/**
 * Component for rendering the national map for state selection.
 *
 * This map is shown in the counties section when no selected state is available
 * to allow a user to easily select one to load the county map.
 *
 * @property prompt - string prompt text drawn in the middle of the gret map
 * @property onClick - callback when a state is clicked (stateFips)
 * @property onAltClick - callback when a state is alt clicked (stateFips)
 *
 * @example
 * return (
 *   <NationalMapSelector
 *     prompt={'Select a state to see county data'}
 *     onClick={this.props.onSelectedStateChange}
 *     onAltClick={this.props.onComparisonStateChange}
 *   />
 * )
 */
export default class NationalMapSelector extends PureComponent {

  static propTypes = {
    prompt: PropTypes.string,
    onClick: PropTypes.func,
    onAltClick: PropTypes.func
  }

  wrapper = React.createRef()

  state = {
    width: 500,
    height: 250
  }

  /**
   * Size map initially
   */
  componentDidMount() {
    this.handleResize(this.wrapper.current.offsetWidth)
  }

  /**
   * Check if window has resized, and size map accordingly
   */
  handleResize = (width) => {
    this.setState({width: width, height: width * .57});
  }

  render() {
    return (
      <div ref={this.wrapper} className="NationalSelector SvgMap SelectorMap">
        <Resize handleWidth onResize={this.handleResize}/>
        <svg
          role="img"
          aria-labelledby="selector-map-desc"
          width={this.state.width}
          height={this.state.height}>
          <desc id="selector-map-desc">{TEXT.accessible_selector_description}</desc>
          <UsaStateHovers
            width={this.state.width}
            height={this.state.height}
            onClick={this.props.onClick}
            onAltClick={this.props.onAltClick}
          />
          <UsaStateBorders
            width={this.state.width}
            height={this.state.height}
          />
          <text
            opacity={0.4}
            fontSize={16}
            textAnchor="middle"
            fontFamily="arial,sans-serif"
            pointerEvents="none"
            x={this.state.width / 2}
            y={this.state.height / 2}
            children={this.props.prompt}
          />
        </svg>
      </div>
    );
  }
}
